<template>
    <FormModal :model="model" :init="init" modal-id="inventory" :beforeSaving="beforeSaving" :onSetIsEditMode="onSetIsEditMode" :hide-footer="true">
        <template>
            <div :key="key" class="d-flex">
                <ItemBadges :model="model" class="mb-1" />
            </div>
        </template>
        <template v-slot:form="{ error: error }">
<!--
            <b-form-input
                v-model="model.uuid"
                size="sm"
                ></b-form-input>
            <input-error :errors="error.uuid" />

            <b-form-input
                v-model="model.name"
                size="sm"
                ></b-form-input>
            <input-error :errors="error.name" />
-->
            <GridPage
                :form-default="{
                }"
                :filters-default="{
                    provider: 'amazon',
                    quantity: '',
                    sort: 'name',
                }"
                :filter-items="[
                    {
                        vModel: 'quantity',
                        title: '在庫',
                        options: [
                            { text: '全て', value: '' },
                            { text: 'あり', value: '1' },
                            { text: 'なし', value: '0' },
                        ],
                    },
                    {
                        vModel: 'sort',
                        title: '順番',
                        options: [
                            { text: '▲ 名前', value: 'name', },
                            { text: '▼ 名前', value: '-name', },
                            { text: '▲ 在庫', value: 'quantity', },
                            { text: '▼ 在庫', value: '-quantity', },
                        ],
                    },
                ]"
                filters-q-placeholder="Name, SKU, ASIN"
                form-modal-id="item"
                search-action="item/index"
                :hide-add="true"
                :row-clicked="false"
                >
                <template v-slot:form="{ form, init }">
                    <Item :model="form" :init="init"></Item>
                </template>

                <template v-slot:column="{ item }">
                    <b-row class="no-gutters w-100">
                        <b-col md="12" class="align-self-center px-3">
                            <strong>{{ item.data.productName }}</strong>
                        </b-col>
                        <b-col xs="6" class="align-self-center px-3">
                            <span>ASIN:{{ item.data.asin }}</span>
                            <br>
                            <span>SKU:{{ item.data.sellerSku }}</span>
                        </b-col>
                        <b-col xs="6" class="align-self-center px-3 text-right">
                            <b-form-checkbox v-model="item.synced" switch @change="toggleSyncedSwitch(item)">
                            </b-form-checkbox>
                            <span>x{{ item.quantity }}</span>
                        </b-col>
                    </b-row>
                </template>
            </GridPage>
        </template>
    </FormModal>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import FormModal from '@/components/FormModal.vue'
import Item from '@/components/Item.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ShareButtons from '@/components/ShareButtons.vue'
import InputError from '@/components/InputError.vue'
import blueimpLoadImage from 'blueimp-load-image'

export default {
    components: {
        GridPage,
        FormModal,
        Item,
        ItemBadges,
        ShareButtons,
        InputError,
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return null
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'trans',
        ])
    },
    mounted() {},
    methods: {
        beforeSaving (model) {
            return Object.assign(model, {})
        },
        onSetIsEditMode (model) {
        },
        dummy ($event) {
//            let tr = $event.target.closest('tr')
//            let checkbox = tr.querySelector('input')
//            if (checkbox)
//                checkbox.click()
        },
        toggleSyncedSwitch (model) {
            if (model.synced) {
                this.$dialog
                    .confirm('do you really want to sync item?', {
                        okText: 'Sync',
                        cancelText: 'Cancel',
                    })
                    .then(async (dialog) => {
                    })
                    .catch(() => {
                        model.synced = false
                    })
            } else {
                this.$dialog
                    .confirm('do you really want to un-sync item?', {
                        okText: 'Un-sync',
                        cancelText: 'Cancel',
                    })
                    .then(async (dialog) => {
                    })
                    .catch(() => {
                        model.synced = true
                    })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
</style>


